import Attention from "../../components/carier/Attention";
import Hero from '../../components/carier/Hero';
import Detail from '../../components/detailCarier/Detail';
import Footer from "../../components/shared/Footer";
import Navbar from '../../components/shared/Navbar';

export default function () {
    return (
        <div className="flex flex-col min-h-screen">
            <Attention />
            <div className="relative">
                <div>
                    <Navbar></Navbar>
                    <Hero></Hero>
                </div>
                <main className="flex-grow">
                    <Detail></Detail>

                </main>
            </div>
            <Footer />
        </div>
    )
}